import script from "./videoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./videoPage.vue?vue&type=script&setup=true&lang=js"

import "./videoPage.vue?vue&type=style&index=0&id=62b6ce66&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62b6ce66"]])

export default __exports__